"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTheme = exports.ThemeProvider = exports.ThemeContext = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactJss = require("react-jss");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ThemeContext = /*#__PURE__*/React.createContext({
  scale: 1,
  foregroundColor: 'rgb(255,255,255)',
  labelColor: 'rgb(255,255,255)',
  backgroundColor: 'rgb(0,0,0)',
  dragOver: {}
}); // Creating a namespaced theming object.

exports.ThemeContext = ThemeContext;
var theming = (0, _reactJss.createTheming)(ThemeContext); // Note that `useTheme` here comes from the `theming` object, NOT from `react-jss` import.

var ThemeProvider = theming.ThemeProvider;
exports.ThemeProvider = ThemeProvider;
var useTheme = theming.useTheme;
exports.useTheme = useTheme;
//# sourceMappingURL=Theme.js.map